import { getItemCustomSelect, getListItemCustomSelect, getSharePointSite } from "../src/taskpane/services/GraphService";
import authModule from "./AuthModule";

export interface IContainerDisplayNames {
    siteDisplayName: string;
    libraryDisplayName: string;
    // The COMPOSITE ISiteInfo.id ("host,sharePointSiteId,webId"), NOT the bare Graph
    // parentReference.siteId used to fetch it - those are different identifiers, and only the
    // composite can be dissected into the SharePoint site id the client list stores.
    siteId?: string;
}

export const getContainerDisplayNames = async (driveId: string, itemId: string): Promise<IContainerDisplayNames> => {
    const [site, libraryDisplayName] = await Promise.all([
        (async () => {
            const siteId: string = (await getListItemCustomSelect(driveId, itemId, "parentReference"))?.parentReference?.siteId;
            if (siteId) {
                return await getSharePointSite(siteId);
            }
            return null;
        })(),
        (async () => {
            return (await getItemCustomSelect(await authModule.getGraphAccessToken(), driveId, null, "name"))?.name;
        })()
    ]);

    return { siteDisplayName: site?.name, libraryDisplayName, siteId: site?.id };
}
